// ViewSubjects.js
import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewSubjects = () => {
  const token = config.token;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]);

  //  ------For TableViewer ------
  const subjectsRef = useRef([]);
  subjectsRef.current = subjects;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}subject`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSubjects(data.data);

        //  ------For TableViewer ------
        const subjectsData = data.data.map((subject) => ({
          subject: subject.subject,
          idNumber: subject.subjectid,
        }));
        setRowData(subjectsData);
        //  ------For TableViewer ------

        setLoading(false);
      });
  }, []);

  const handleEditBtn = (subjectId) => {
    navigate(`/addsubject/${btoa(encodeURIComponent(subjectId))}`);
  };

  const handleDeleteBtn = async (subjectId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Subject. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${config.host_url}subject/${subjectId}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data.status === 200) {
              triggerNotification("success", "Subject deleted successfully");

              //  ------For TableViewer ------
              const updatedSubject = [...subjectsRef.current];
              updatedSubject.splice(i, 1);
              setSubjects(updatedSubject);
              const subjectsData = updatedSubject.map((subject) => ({
                subject: subject.subject,
                idNumber: subject.subjectid,
              }));
              setRowData(subjectsData);
              //  ------For TableViewer ------
            } else if (data.status === 404) {
              triggerNotification("error", "Subject not found");
            } else if (data.status === 401) {
              triggerNotification("error", "Unauthenticated User");
            } else {
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!"
              );
            }
          })
          .catch(function (error) {
            console.error("Error:", error);
            triggerNotification("error", "Error deleting Subject");
          });
      }
    });
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "subject", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Subject" subpath={["View Subjects"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Subjects</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addsubject");
                }}
              >
                Add Subject
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewSubjects;
